var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    { attrs: { disabled: _vm.disabled, title: _vm.title } },
    [
      _c(
        "div",
        { staticStyle: { width: "100%" } },
        [
          _c("v-row", { attrs: { dense: "" } }, [_c("v-divider")], 1),
          _c(
            "v-row",
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.values,
                  "item-text": "key",
                  "item-value": "key",
                  label: "Select Currency",
                  chips: "",
                  "small-chips": "",
                  "deletable-chips": "",
                  "return-object": "",
                  multiple: "",
                  hint: "The currency will be reset when the event starts.",
                  "persistent-hint": "",
                },
                model: {
                  value: _vm.value,
                  callback: function ($$v) {
                    _vm.value = $$v
                  },
                  expression: "value",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }